"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericMapPoint = exports.GenericPointCSS = void 0;
const theme_1 = require("../../../components/theme");
const theme_palette_1 = require("../../../components/theme.palette");
const mithril_1 = require("../../../mithril");
const classnames_1 = require("../../../util/classnames");
const CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 0.75;
const CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';
const CIRCLE_BORDER_SIZE = 2;
exports.GenericPointCSS = {
    container: 'c-GenericMapPoint',
    isClickable: 'c-GenericMapPoint--clickable',
};
const GenericPointStyles = {
    [exports.GenericPointCSS.container]: {
        height: CIRCLE_SIZE_PX,
        width: CIRCLE_SIZE_PX,
        minWidth: CIRCLE_SIZE_PX,
        maxWidth: CIRCLE_SIZE_PX,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        border: `${CIRCLE_BORDER_SIZE}px solid ${(0, theme_1.rgba)(theme_palette_1.BLACK, 0.5)}`,
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        transition: ['box-shadow'],
        transitionDuration: 150,
    },
    [`${exports.GenericPointCSS.container}.${exports.GenericPointCSS.isClickable}`]: {
        cursor: 'pointer',
    },
    [`${exports.GenericPointCSS.container}.${exports.GenericPointCSS.isClickable}:hover`]: {
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2w5,
    },
};
(0, theme_1.addStyles)(GenericPointStyles);
exports.GenericMapPoint = {
    view({ key, point, backgroundColor, onClick, title, additionalClasses, additionalStyles }) {
        let mouseDownPos = null;
        const DRAG_THRESHOLD = 5; // pixels
        return (0, mithril_1.m)('div', {
            key,
            className: (0, classnames_1.classNames)(exports.GenericPointCSS.container, additionalClasses, {
                [exports.GenericPointCSS.isClickable]: !!onClick,
            }),
            onmousedown: (e) => {
                mouseDownPos = { x: e.clientX, y: e.clientY };
            },
            onclick: (e) => {
                if (!onClick)
                    return;
                // Check if this was a drag or a click
                if (mouseDownPos) {
                    const mouseEvent = e;
                    const dx = Math.abs(mouseEvent.clientX - mouseDownPos.x);
                    const dy = Math.abs(mouseEvent.clientY - mouseDownPos.y);
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    // If mouse moved more than threshold, it's a drag - don't trigger click
                    if (distance > DRAG_THRESHOLD) {
                        mouseDownPos = null;
                        return;
                    }
                }
                mouseDownPos = null;
                onClick(e);
            },
            title,
            style: Object.assign({ top: point.y - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE + 'px', left: point.x - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE + 'px', backgroundColor }, additionalStyles),
        });
    },
};
//# sourceMappingURL=map.point.generic.js.map